import React, { useContext } from "react";

//fetch graphQL
import fetch from "isomorphic-fetch";

// Package to access url params
import qs from "query-string";

//access browser history
import { useHistory } from "react-router-dom";

//fade in effect
import FadeIn from "react-fade-in";

// components
import WeaviateURICheckerModal from "../../components/console/GeneralModal";
import GraphiQLComponent from "./GraphiQLComponent";

//helper functions
import { headerObj, getQuery, updateToNewWeaviateFromURL } from "./helpers";

// global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

const ModuleContent = ({ isURICheckerModalOpen, setIsURICheckerModalOpen }) => {
  // global state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  // To use history
  const history = useHistory();

  // query params if there is any
  const hashObj = qs.parse(window.location.hash);

  // Needed for GraphiQL to work
  async function graphQLFetcher(graphQLParams, opts) {
    let providedHeader = opts.headers;
    let hardcodedHeader = headerObj();
    let finalHeaders = {
      ...providedHeader,
      ...hardcodedHeader,
    };
    if ("weaviate_uri" in hashObj) {
      const response = await fetch(`${hashObj.weaviate_uri}/v1/graphql`, {
        method: "post",
        headers: finalHeaders,
        body: JSON.stringify(graphQLParams),
      });
      return await response.json();
    } else {
      const response = await fetch(`${state.connectToWeaviateURI}/v1/graphql`, {
        method: "post",
        headers: finalHeaders,
        body: JSON.stringify(graphQLParams),
      });
      return await response.json();
    }
  }

  //cancels and goes back to the module
  const closeModal = () => {
    setIsURICheckerModalOpen(false);
    history.push("/console/Query");
  };

  // This function triggers if the user clicks on proceed.
  const proceed = () => {
    setIsURICheckerModalOpen(false);
    updateToNewWeaviateFromURL(hashObj, state, setState);
  };

  return (
    <FadeIn transitionDuration={1000}>
      <div style={{ height: "92.3vh" }}>
        <GraphiQLComponent
          fetcher={graphQLFetcher}
          getQuery={getQuery}
          state={state}
        />

        <WeaviateURICheckerModal
          title='Update Weaviate instance?'
          text={`Proceeding will disconnect you from ${
            state.connectToWeaviateURI
          } and connect to ${
            hashObj.weaviate_uri || "the new instance"
          } instead. Would you like to proceed?`}
          actionText='Proceed'
          cancelText='Cancel'
          modalDescription='update Weaviate URI modal dialog'
          open={isURICheckerModalOpen}
          closeModal={closeModal}
          cancelFunction={closeModal}
          actionFunction={proceed}
          id='weaviateURICheckerModal'
          actionButtonId='weaviateURICheckerProceedButton'
        />
      </div>
    </FadeIn>
  );
};

export default ModuleContent;
